module.exports = __webpack_public_path__ + "img/AU.8996025a.webp";